/* lib/table/serverRegistryCache.js — снимки серверных реестров (ServerRegistry) для
   возврата на страницу: строки загруженных страниц, раскрытые группы, прокрутка,
   последняя открытая строка. Ключ — таблица и пространство (columnStoreKey + '|srv').

   Живёт в памяти вкладки, отдельным маленьким модулем — чтобы выход (AuthProvider.logout)
   и смена пользователя во вкладке (WorkspaceTabSync) могли его очистить, не подтягивая
   сам реестр: данные прежнего пользователя следующему не показываются (S10). */

const CACHE = new Map();

export const serverRegistryCache = {
  get: (key) => CACHE.get(key),
  set: (key, value) => { CACHE.set(key, value); },
  delete: (key) => CACHE.delete(key),
  size: () => CACHE.size,
};

/** Забыть все снимки (выход, вход под другим пользователем, тесты). */
export function clearServerRegistryCache() {
  CACHE.clear();
}
